import { BaseActivityBasicModel } from '../base-activity-basic.model';

export interface SmsActivityBasicModel extends BaseActivityBasicModel {}
